"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlaylistForWorkout = exports.WorkoutPlaylistEntryType = void 0;
const lodash_1 = require("lodash");
var WorkoutPlaylistEntryType;
(function (WorkoutPlaylistEntryType) {
    WorkoutPlaylistEntryType[WorkoutPlaylistEntryType["HAS_INSTRUCTIONS"] = 0] = "HAS_INSTRUCTIONS";
    WorkoutPlaylistEntryType[WorkoutPlaylistEntryType["NO_INSTRUCTIONS"] = 1] = "NO_INSTRUCTIONS";
    WorkoutPlaylistEntryType[WorkoutPlaylistEntryType["BREAK"] = 2] = "BREAK";
    WorkoutPlaylistEntryType[WorkoutPlaylistEntryType["CUSTOM"] = 3] = "CUSTOM";
})(WorkoutPlaylistEntryType = exports.WorkoutPlaylistEntryType || (exports.WorkoutPlaylistEntryType = {}));
exports.getPlaylistForWorkout = (workout, isPregnant) => {
    const { exercises } = workout;
    let actualIndex = 0;
    const playlistWithNulls = exercises.map((exercise) => {
        if (exercise.name === 'break') {
            return {
                type: WorkoutPlaylistEntryType.BREAK,
                name: 'break',
                index: -1,
                videoSourceName: 'take-a-break.mp4',
                videoThumbName: 'take-a-break.png',
                preComposited: true,
            };
        }
        else {
            // not a break
            actualIndex++;
            let eVideo, eThumb;
            if (exercise.isCustom) {
                return {
                    type: WorkoutPlaylistEntryType.CUSTOM,
                    name: exercise.name,
                    description: exercise.description,
                    index: actualIndex
                };
            }
            if (isPregnant) {
                // check if there's a prenatal vid. Unfortunately, because of firebase, a lack of video is an empty object {}
                if (exercise.prenatalVideo.name) {
                    eVideo = exercise.prenatalVideo;
                }
                else if (exercise.postnatalVideo.name) {
                    eVideo = exercise.postnatalVideo;
                }
                else {
                    console.warn(`Exercise ${exercise.name} has no videos at all, skipping`);
                    return null;
                }
            }
            else {
                if (exercise.postnatalVideo.name) {
                    eVideo = exercise.postnatalVideo;
                }
                else if (exercise.prenatalVideo.name) {
                    eVideo = exercise.prenatalVideo;
                }
                else {
                    console.warn(`Exercise ${exercise.name} has no videos at all, skipping`);
                    return null;
                }
            }
            if (isPregnant) {
                // check if there's a prenatal vid. Unfortunately, because of firebase, a lack of video is an empty object {}
                if (exercise.prenatalThumb.name) {
                    eThumb = exercise.prenatalThumb;
                }
                else if (exercise.postnatalThumb.name) {
                    eThumb = exercise.postnatalThumb;
                }
                else {
                    console.warn(`Exercise ${exercise.name} has no thumbs at all, skipping`);
                    return null;
                }
            }
            else {
                if (exercise.postnatalThumb.name) {
                    eThumb = exercise.postnatalThumb;
                }
                else if (exercise.prenatalThumb.name) {
                    eThumb = exercise.prenatalThumb;
                }
                else {
                    console.warn(`Exercise ${exercise.name} has no thumbs at all, skipping`);
                    return null;
                }
            }
            const entry = {
                index: actualIndex,
                name: exercise.name,
                videoSourceName: eVideo.name,
                videoThumbName: eThumb.name,
                preComposited: exercise.preComposited,
            };
            if (exercise.instructionVideo &&
                exercise.instructionVideo.name) {
                // exercise has instructions
                const { name: instVidName } = exercise.instructionVideo;
                const { name: instThumbName } = exercise.instructionThumb;
                const instructionSourceName = instVidName;
                const instructionThumbName = instThumbName ? instThumbName : undefined;
                return Object.assign(Object.assign({}, entry), { type: WorkoutPlaylistEntryType.HAS_INSTRUCTIONS, instructionSourceName,
                    instructionThumbName });
            }
            else {
                return entry;
            }
        }
    });
    // remove nulls
    return lodash_1.compact(playlistWithNulls);
};
//# sourceMappingURL=WorkoutPlaylist.js.map